var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('span',[_vm._v("Успешно склеено: ")]),_vm._v(_vm._s(_vm.successCount)+"\n    ")]),_vm._v(" "),_c('div',[_c('span',[_vm._v("Не склеено: ")]),_vm._v(_vm._s(_vm.errorsCount)+"\n    ")]),_vm._v(" "),_vm._l((_vm.errors),function(error){return _c('div',[_vm._v("\n        "+_vm._s(error)+"\n    ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }